import React from 'react';

const Spinner = () => {
  return (
    <div
      className={`relative min-h-5 h-full w-full aspect-square min-w-5 mr-3 rounded-full border border-blue-900 border-r-white animate-spin`}
    >
      {/* <svg>
        <circle cx={12} cy={12} radius={10} strokeWidth={4}></circle>
      </svg> */}
    </div>
  );
};

export default Spinner;
